//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import AbsenceRequestListView from '@/views/HumanResource/HrAbsenceRequest/AbsenceRequestList'
import AbsenceRequestCreateView from '@/views/HumanResource/HrAbsenceRequest/AbsenceRequestCreate'

//
export default {
    path: 'absence_request',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'absence-request-list',
            component: AbsenceRequestListView,
        },
        {
            path: 'create',
            name: 'absence-request-create',
            component: AbsenceRequestCreateView,
            meta: {
                title: 'Crear solicitud de ausencia',
            },
        },
    ],
    meta: {
        title: 'Solicitudes de ausencia',
    },
}
